import { CrashRenderingConfig } from "../crash-rendering-config.interface";
import { CrashRenderingLayer } from "../crash-rendering-layer";
import { CrashRenderingState } from "../crash-rendering-state.interface";
import { ImageHelper } from "@tgg/shared";
import Konva from "konva";
import shuttleSpriteSheet from "../assets/shuttle-sprite-sheet.json";

export class CrashRenderingCountdownPage extends CrashRenderingLayer<{
    timer: Konva.Text;
    subtitle: Konva.Text;
    shuttle: Konva.Sprite;
}> {
    public constructor(configuration: CrashRenderingConfig, container: Konva.Group) {
        super(
            configuration,
            container,
            {
                shuttle: new Konva.Sprite(
                    {
                        animation: "fly",
                        animations: shuttleSpriteSheet.animations,
                        frameRate: shuttleSpriteSheet.framerate,
                        frameIndex: 0,
                        offsetX: shuttleSpriteSheet.width / 2,
                        offsetY: shuttleSpriteSheet.height / 2,
                        scale: { x: 0.75, y: 0.75 },
                    }
                ).transformsEnabled("all"),
                timer: new Konva.Text(
                    {
                        fillEnabled: true,
                        align: "center",
                        verticalAlign: "middle",
                        fontFamily: "Fira Code",
                        fontSize: 30,
                        x: 0,
                        fill: "#ffffff",
                    }
                ).transformsEnabled("position"),
                subtitle: new Konva.Text(
                    {
                        fillEnabled: true,
                        align: "center",
                        verticalAlign: "middle",
                        fontFamily: "Montserrat",
                        fontSize: 12,
                        x: 0,
                        fill: "#909090",
                    }
                ).transformsEnabled("position"),
            }
        );

        ImageHelper.loadImage(shuttleSpriteSheet.image).then(
            (e) => {
                this.shapes.shuttle.image(e);
                this.shapes.shuttle.start();
            },
            () => {
                // ignore
            }
        );

        this.config(configuration);
        this.resize();
    }

    public resize(): void {
        const width = this.width;
        const height = this.height;
        this.shapes.shuttle.x(width / 2);
        this.shapes.shuttle.y((height / 2) - 40);

        this.shapes.timer.width(width);
        this.shapes.timer.y((height / 2) + 25);

        this.shapes.subtitle.width(width);
        this.shapes.subtitle.y((height / 2) + 25 + 40);
        super.resize();
    }

    public tick(state: CrashRenderingState): void {
        super.tick(state);
        // draw countdown
        if (state.countdown != null) {
            this.shapes.timer.text((state.countdown / 1000).toFixed(2) + "s");
            this.shapes.subtitle.text("Getting ready to launch");
        } else {
            this.shapes.subtitle.text("");
        }
    }
}
